import { REDUCERS } from '../../constants/reducers';

import { NotificationService } from '../../services';

export const setNotificationList = value => ({
  type: REDUCERS.NOTIFICATION.SET_NOTIFICATION_LIST,
  value
});

export const setNotificationState = value => ({
  type: REDUCERS.NOTIFICATION.SET_NOTIFICATION_STATE,
  value
});

export const setSelectedFilters = value => ({
  type: REDUCERS.NOTIFICATION.SET_SELECTED_FILTERS,
  value
});

export const fetchDataRequest = () => ({
  type: REDUCERS.NOTIFICATION.FETCH_DATA_REQUEST
});

export const fetchDataFailure = error => ({
  type: REDUCERS.NOTIFICATION.FETCH_DATA_FAILURE,
  payload: error
});

export const getNotifications = params => {
  return async dispatch => {
    dispatch(fetchDataRequest());

    try {
      const { data } = await NotificationService.getNotifications(params);
      const payload = {
        alerts: data?.notifications,
        alertsCount: data?.count
      };
      dispatch(setNotificationState(payload));
      return data;
    } catch (error) {
      dispatch(fetchDataFailure(error.message));
    }
  };
};
